import React, { createContext, useContext } from 'react'
import PropTypes from 'prop-types'

export const SignOutContext = createContext()

export const SignOutContextProvider = ({ children, signOut }) => {
  return (
    <SignOutContext.Provider value={signOut}>
      {children}
    </SignOutContext.Provider>
  )
}

SignOutContextProvider.propTypes = {
  children: PropTypes.node,
  signOut: PropTypes.func
}

export const useSignOut = () => {
  const context = useContext(SignOutContext)
  return context
}

